/**
 * HomepageLatestUpdate Block Template
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders HomepageLatestUpdate Block
 */
import React, { useEffect, useState, useRef } from 'react';
import { SVBTypography } from '@svb/svb-react-components';
import Loading from "@svb/api-loading-component/dist/components/index";
// import { Utils } from '@svb/api-content-component';
import { browseAPIhandler } from '../../helpers/browseAPIhandler';
import { getFileContent } from '../../helpers/utilityFunctions';
import Carousel from 'react-bootstrap/Carousel';
import { SVBCard } from '@svb/svb-react-components';
import { getWindowSize } from '../../core/getWindowSize';
import { slugCreator } from "../../core/useStore";


/**
  * HomepageLatestUpdate
  * @param content: url of the HomepageIntegratedSolutions content
  * @returns HomepageLatestUpdate block 
*/

const HomepageLatestUpdate = ({ datatestid, testMockContent, content }) => {
  const [loading, setLoading] = useState(true);
  const [slideCount, setSlideCount] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDesktop, setDesktop] = useState(false);
  const [isiPhone, setiPhone] = useState(false);
  const [slide , setSlide ] = useState(3);
  const cWindowSize = getWindowSize();
  // const cardColumn = 12 / slide;
  const reduceCards = (acc, cur, index) => {
    const groupIndex = Math.floor(index / slide);
    if (!acc[groupIndex]) acc[groupIndex] = [];
    acc[groupIndex].push(cur);
    return acc;
  };
  const ref = useRef(null);
  // const token = localStorage.getItem('token');
  const { regenTokenandBrowse } = browseAPIhandler();
  const getHomepageLatestSectionContent = datatestid ? testMockContent : getFileContent(`${content}`, regenTokenandBrowse);
  useEffect(() => {
    if (getHomepageLatestSectionContent.type === 'success') {
      setLoading(false)
      const subTitle = Object.keys(getHomepageLatestSectionContent.response);
      const sliderItems = getHomepageLatestSectionContent.response[subTitle];
      setSlideCount(Math.ceil((sliderItems.length)/slide) );
    }

  }, [getHomepageLatestSectionContent.response, slide])

  useEffect(()=>{
    const iPadRes = window.innerWidth;
    if(iPadRes >= 1025){
      setDesktop(false);
      setSlide(3);
    }else if(iPadRes >= 768 && iPadRes <= 1024){
        setDesktop(true);
        setSlide(2);
    }else{
      setiPhone(true);
      setSlide(1);
    }
  }, [cWindowSize?.width])
  if (loading) {
    return <Loading />
  }
  const onPrevClick = () => {
    if(currentIndex > 0){
      setCurrentIndex(currentIndex -1 );
      ref.current.prev();
  }
  };
  const onNextClick = () => {
    if(currentIndex < slideCount-1){
      setCurrentIndex(currentIndex + 1 );
      ref.current.next();
  }
  };

  const sectionTitle = Object.keys(getHomepageLatestSectionContent.response);
  return (
    <section id="homepage-latestupdate" className='latestupdate-section'>
      <div className="container svb-container-fixed col-md-9 col-sm-12">
        <SVBTypography type="heading-large" variant="header-2">{sectionTitle}</SVBTypography>
        <div className="homepage_hero__Subseparation"></div>
        <div className={isiPhone ? 'd-flex flex-row justify-content-between' : 'row'}>
          <div className='col-1 col-md-1 svb-control-container'>
            <div className={currentIndex === 0 ? "svb-carousel-control-prev-wrapper disabled" : "svb-carousel-control-prev-wrapper"} onClick={onPrevClick}>
            <span  className="svb-carousel-control-prev">
              <i className='fa fa-chevron-left'></i>
            </span>
            </div>

          </div>
          <div className="cards col-10 col-md-10 px-2 px-md-3 px-lg-0"> 
            <Carousel bsPrefix="carousel" indicators={false} interval={null} ref={ref} controls={false}>
              {getHomepageLatestSectionContent.response[sectionTitle].reduce(reduceCards, []).map((item, index) => (
                <Carousel.Item key={index}>
                  <div className="row">
                    {item.map((item, index) => {
                      const cardOptions = {
                        cardClickable: false
                      }
                      const cardTestid = slugCreator("card-"+item.title);
                      return (
                        <div key={index} className={isDesktop ? 'col-md-6 col-sm-12 align-item-stretch d-flex mb-4' : 'col-md-4 col-sm-12 align-item-stretch d-flex mb-4'}>
                          <SVBCard
                            cardIcon={item.cardIcon}
                            iconLabel={item.iconLabel}
                            title={item.title}
                            description={item.description}
                            cardOptions={cardOptions}
                            explicitImgWidth={16}
                            explicitImgHeight={16}
                            lazyLoading={true}
                            datatestid={{card: cardTestid, learnMore: ''}}
                          />
                          </div>
                      );
                    })}
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
          <div className='col-1 col-md-1 svb-control-container'>
          <div className={ currentIndex === (slideCount-1) ? "svb-carousel-control-next-wrapper disabled" : "svb-carousel-control-next-wrapper" } onClick={onNextClick}>
          <span  className="svb-carousel-control-next">
              <i className='fa fa-chevron-right'></i>
            </span>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );

}

export default HomepageLatestUpdate;